import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import CheckIndicator from '../checkindicator/CheckIndicator'
import MainButton from '../common/util/input/MainButton'
import { getBoostAction } from '../helpers/WaxApi'
import { PopupLoadingIndicator } from '../loadingindicator/PopupLoadingIndicator'
import ErrorMessage from './ErrorMessage'
import Popup from './Popup'
import { useSharedState } from '../waxplorer/Waxplorer'

function BulkSwapPopup(props) {
    const assets = props['assets']

    const { t } = useTranslation('common')

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const callBack = props['callBack']
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState()
    const closeCallBack = props['closeCallBack']
    const [errors, setErrors] = useState({})
    const [transferred, setTransferred] = useState([])
    const [transactions, setTransactions] = useState({})

    const addError = (assetId, e) => {
        errors[assetId] = e
        setErrors(errors)
    }

    const addTransaction = (assetId, tx) => {
        transactions[assetId] = tx
        setTransactions(transactions)
    }

    const transfer = async () => {
        setIsLoading(true)

        let transferError = null

        const actions = [getBoostAction(activeUser)]

        const simpleAssetIds = []
        const atomicAssetIds = []
        Object.keys(assets).map((assetId) => {
            const asset = assets[assetId]

            if (asset.contract === 'simpleassets')
                simpleAssetIds.push(asset.assetId)

            if (asset.contract === 'atomicassets')
                atomicAssetIds.push(asset.assetId)
        })

        if (simpleAssetIds.length > 0) {
            actions.push({
                account: 'simpleassets',
                name: 'transfer',
                authorization: [
                    {
                        actor: userName,
                        permission: activeUser.requestPermission
                            ? activeUser.requestPermission
                            : 'active',
                    },
                ],
                data: {
                    from: userName,
                    to: 'atomicbridge',
                    assetids: simpleAssetIds,
                    memo: 'swap',
                },
            })
        }

        if (atomicAssetIds.length > 0) {
            actions.push({
                account: 'atomicassets',
                name: 'transfer',
                authorization: [
                    {
                        actor: userName,
                        permission: activeUser.requestPermission
                            ? activeUser.requestPermission
                            : 'active',
                    },
                ],
                data: {
                    from: userName,
                    to: 'atomicbridge',
                    asset_ids: atomicAssetIds,
                    memo: 'swap',
                },
            })
        }

        try {
            const result = await activeUser.session.transact(
                {
                    actions: actions,
                },
                {
                    expireSeconds: 300,
                    blocksBehind: 0,
                },
            )
            Object.keys(assets)
                .sort((a, b) => parseInt(a.value) - parseInt(b.value))
                .map((assetId) =>
                    addTransaction(
                        assetId,
                        result['response']['transaction_id'],
                    ),
                )
        } catch (e) {
            Object.keys(assets).map((asset) => addError(asset, e.message))
            console.error(e)
            setError(e.message)
            transferError = e
        } finally {
            if (!error && !transferError) {
                Object.keys(assets)
                    .sort((a, b) => parseInt(a.value) - parseInt(b.value))
                    .map((assetId) => transferred.push(assets[assetId]))
                setTransferred(true)
            }
        }
        setIsLoading(false)
        callBack({
            transferred: true,
            errors: errors,
            transactionIds: transactions,
        })
        closeCallBack()
    }

    let transferInfo = t('asset.transfer')

    const transferField = (
        <MainButton className="w-[80px] max-w-32" onClick={transfer}>
            {transferInfo}
        </MainButton>
    )

    const cancel = () => {
        callBack({
            transferred: false,
            errors: errors,
            transactionIds: transactions,
        })
        closeCallBack()
    }

    return (
        <Popup title={t('search.bulk_transfer')} cancel={cancel}>
            <div className="p-2">
                {Object.keys(transferred).length > 0 ? <CheckIndicator /> : ''}
                {Object.keys(transferred).length === 0 ? (
                    <div className="mx-auto mb-4 text-lg font-bold text-center">
                        {t('popups.swapping_x_assets_to_atomicassets', {
                            number: Object.keys(assets).length,
                        })}
                    </div>
                ) : (
                    ''
                )}
                {error ? <ErrorMessage error={error} /> : ''}
                {Object.keys(transferred).length === 0 ? (
                    <div className="relative flex justify-center gap-2">
                        <MainButton onClick={cancel} className="bg-red-500 ">
                            {t('asset.cancel')}
                        </MainButton>
                        {transferField}
                    </div>
                ) : (
                    ''
                )}
                {isLoading ? (
                    <PopupLoadingIndicator
                        text={t('popups.loading_transaction')}
                        isLoading={isLoading}
                    />
                ) : (
                    ''
                )}
            </div>
        </Popup>
    )
}

export default BulkSwapPopup
